const music_list = [
  {
    img: "https://i.ytimg.com/vi/MJmxdlCtFWU/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBgBwsqLjtQ3kwEBFdAQk1BA1Z6cw",
    name: "Two Two Two",
    film: "Kaathuvaakula Rendu Kaadhal",
    artist: "Anirudh",
    music: "/music/Two Two Two.mp3",
  },
  {
    img: "https://i0.wp.com/99lyricstore.com/wp-content/uploads/2021/10/jugnu-lyrics-badshah.jpg",
    name: "Jugnu",
    film: "Badshah",
    artist: "Nikhita Gandhi | Akanksha Sharma",
    music: "/music/Jugnu.mp3",
  },
  {
    img: "https://i.ytimg.com/vi/WgrLE4Fqxeo/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLChxO0w-PnVS3BHxzppCEkDJLYItw",
    name: "Bullet",
    film: "The Warrior",
    artist: "DSP",
    music: "/music/Bullet.mp3",
  },
  {
    img: "https://i.ytimg.com/vi/Y3-PeuQ7nvY/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLD0X9wJRcr-CnZsdyity_untFPoF",
    name: "Yanji",
    film: "Vikram Vedha",
    artist: "Sam C.S",
    music: "/music/Yanji.mp3",
  },
];

// helpers

const zeroPad = (num) => String(num).padStart(2, "0");

function secondsToMinutes(time) {
  return zeroPad(Math.floor(time / 60)) + ":" + zeroPad(Math.floor(time % 60));
}

let track_index = 0;
let isPlaying = false;
let isRandom = false;
let updateTimer;
let currTrack = document.createElement("audio");

const musicMetaName = document.querySelector(".music-meta_name");
const musicMetaFilm = document.querySelector(".music-meta_film");
const musicMetaArtist = document.querySelector(".music-meta_artist");
const albumArt = document.querySelector(".album-art");
const playPauseBtn = document.querySelector(".playpause-track");

loadTrack(track_index);

function loadTrack(track_index) {
  //   reset();
  clearInterval(updateTimer);
  //   updateTimer = setInterval(setUpdate, 1000);
  const { music } = music_list[track_index];
  currTrack.src = music;
  currTrack.load();
  currTrack.addEventListener("ended", nextTrack);
  updateMetaData(track_index);
  console.log(currTrack);
}

function repeatTrack() {
  loadTrack(track_index);
  playTrack();
}

function randomTrack() {
  isRandom = !isRandom;
}

function updateMetaData(track_index) {
  clearInterval(updateTimer);
  const { img, name, film, artist } = music_list[track_index];
  //   track_art.style.backgroundImage = `url(${img})`;
  albumArt.src = img;
  musicMetaName.textContent = name;
  musicMetaFilm.textContent = film;
  musicMetaArtist.textContent = artist;

  updateTimer = setInterval(setUpdate, 1000);
}

function nextTrack() {
  const currentIndex = isRandom
    ? Number.parseInt(Math.random() * music_list.length)
    : track_index + 1;

  track_index = currentIndex % music_list.length;
  loadTrack(track_index);
  playTrack();
}

function prevTrack() {
  const currentIndex = isRandom
    ? Number.parseInt(Math.random() * music_list.length)
    : track_index - 1;

  track_index = Math.max(0, currentIndex);
  loadTrack(track_index);
  playTrack();
}

function playTrack() {
  currTrack.play();
  isPlaying = true;
  albumArt.classList.add("rotate");
  playPauseBtn.innerHTML = ' <i class="fa fa-pause fa-3x"></i>';
  //   waves(currTrack);
}

function playpauseTrack() {
  isPlaying ? pauseTrack() : playTrack();
}

function pauseTrack() {
  currTrack.pause();
  isPlaying = false;
  albumArt.classList.remove("rotate");
  playPauseBtn.innerHTML = ' <i class="fa fa-play fa-3x"></i>';
}

let startTime = document.querySelector(".start-time");
let endTime = document.querySelector(".end-time");

function setUpdate() {
  let seekPosition = (currTrack.currentTime / currTrack.duration) * 100;
  seekBar.value = seekPosition;
  startTime.textContent = secondsToMinutes(currTrack.currentTime);
  endTime.textContent = secondsToMinutes(currTrack.duration);
  console.log(currTrack.currentTime);
  updateSeekBarFilled();
}

function updateSeekBarFilled() {
  seekBarFilled.style.width = seekBar.value - 1 + "%";
}

function seekTo() {
  currTrack.currentTime = currTrack.duration * (seekBar.value / 100);
  console.log(
    currTrack.duration,
    secondsToMinutes(currTrack.duration),
    secondsToMinutes(currTrack.currentTime)
  );
}

function waves(audio) {
  var context = new AudioContext();
  var src = context.createMediaElementSource(audio);
  var analyser = context.createAnalyser();

  var canvas = document.getElementById("canvas");
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  var ctx = canvas.getContext("2d");

  src.connect(analyser);
  analyser.connect(context.destination);

  analyser.fftSize = 256;

  var bufferLength = analyser.frequencyBinCount;
  console.log(bufferLength);

  var dataArray = new Uint8Array(bufferLength);

  var WIDTH = canvas.width;
  var HEIGHT = canvas.height;
  //   var HEIGHT = "400";

  var barWidth = (WIDTH / bufferLength) * 2.5;
  var barHeight;
  var x = 0;

  function renderFrame() {
    requestAnimationFrame(renderFrame);

    x = 0;

    analyser.getByteFrequencyData(dataArray);

    var my_gradient = ctx.createLinearGradient(0, 0, 0, 170);
    my_gradient.addColorStop(0, "black");
    my_gradient.addColorStop(1, "white");

    ctx.fillStyle = my_gradient;
    // ctx.fillStyle = "transparent";
    ctx.fillRect(0, 0, WIDTH, HEIGHT);

    for (var i = 0; i < bufferLength; i++) {
      barHeight = dataArray[i];

      var r = barHeight + 2 * (i / bufferLength);
      var g = 250 * (i / bufferLength);
      var b = 50;

      ctx.fillStyle = "rgb(" + r + "," + g + "," + b + ")";
      ctx.fillRect(x, HEIGHT - barHeight, barWidth, barHeight);

      x += barWidth + 1;
    }
  }

  // audio.play();
  renderFrame();
}
